import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, ClipboardList, BarChart3, Eye, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Hero() {
  const words = ['soluciona', 'ordena', 'agiliza'];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % words.length);
    }, 1800);
    return () => clearInterval(interval);
  }, []);
  return <section className="pt-28 pb-20 md:pt-36 md:pb-24 px-6 bg-gradient-to-b from-white to-brand-50/30 overflow-hidden" data-id="element-100">
      <div className="max-w-6xl mx-auto" data-id="element-101">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-102">
          {/* LEFT */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-103">
            <span className="inline-block py-1 px-3 rounded-full bg-gray-100 text-gray-600 text-xs font-medium mb-5" data-id="element-104">
              Para personas que buscan arriendo
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 leading-[1.15]" data-id="element-105">
              Arrendar hoy es lento, confuso y desordenado
              <span className="inline-block" data-id="element-106">,</span>
            </h1>

            {/* FRASE DINÁMICA */}
            <div className="mt-2 mb-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.15] text-brand-600" data-id="element-107">
              Rentual lo{' '}
              <span className="relative inline-block" data-id="element-108">
                <span data-id="element-109">{words[index]}</span>
                <span className="absolute left-0 bottom-0 w-full h-[3px] bg-black" data-id="element-110"></span>
              </span>
            </div>

            <p className="text-base text-gray-600 mb-8 leading-relaxed max-w-lg" data-id="element-111">
              Cada corredor pide cosas distintas. Cada arrendatario postula a
              ciegas. Rentual te muestra solo dónde realmente tienes opción.
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-3 mb-8" data-id="element-112">
              <Link to="/score" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-8 py-4 rounded-full font-medium transition-all text-base shadow-lg shadow-brand-600/20" data-id="element-113">
                Ver opciones
              </Link>

              <button className="w-full sm:w-auto flex items-center justify-center gap-2 text-gray-500 hover:text-gray-700 px-5 py-4 rounded-full font-medium transition-colors text-sm" data-id="element-114">
                Ver cómo funciona
                <ChevronDown size={16} data-id="element-115" />
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-x-6 gap-y-3" data-id="element-116">
              <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium" data-id="element-117">
                <ClipboardList size={14} className="text-brand-500" data-id="element-118" />
                <span data-id="element-119">Te hacemos 5 preguntas clave</span>
              </div>

              <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium" data-id="element-120">
                <BarChart3 size={14} className="text-brand-500" data-id="element-121" />
                <span data-id="element-122">Analizamos tu perfil en segundos</span>
              </div>

              <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium" data-id="element-123">
                <Eye size={14} className="text-brand-500" data-id="element-124" />
                <span data-id="element-125">Solo ves arriendos donde calificas</span>
              </div>

              <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium" data-id="element-126">
                <Zap size={14} className="text-brand-500" data-id="element-127" />
                <span data-id="element-128">Todo en menos de 1 minuto</span>
              </div>
            </div>
          </motion.div>

          {/* RIGHT */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} className="relative" data-id="element-129">
            {/* CARD PRINCIPAL */}
            <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-6 max-w-md ml-auto relative" data-id="element-130">
              <div className="flex items-center justify-between mb-4" data-id="element-131">
                <span className="text-xs text-gray-400 font-medium" data-id="element-132">
                  RESULTADO RENTUAL
                </span>
                <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded-full font-medium" data-id="element-133">
                  FILTRADO
                </span>
              </div>

              <h3 className="text-lg font-semibold mb-1" data-id="element-134">
                5 arriendos donde realmente puedes arrendar
              </h3>

              <p className="text-sm text-gray-500 mb-4" data-id="element-135">
                Filtrado según tu perfil y requisitos reales.
              </p>

              <div className="space-y-3 mb-4" data-id="element-136">
                <div className="flex items-center justify-between text-sm" data-id="element-137">
                  <div className="flex items-center gap-2" data-id="element-138">
                    <span className="w-6 h-6 rounded-md bg-brand-100 text-brand-600 text-xs flex items-center justify-center font-semibold" data-id="element-139">
                      1
                    </span>
                    <span data-id="element-140">Ñuñoa · 1D+1B</span>
                  </div>
                  <span className="font-medium" data-id="element-141">$720.000</span>
                </div>

                <div className="flex items-center justify-between text-sm" data-id="element-142">
                  <div className="flex items-center gap-2" data-id="element-143">
                    <span className="w-6 h-6 rounded-md bg-brand-100 text-brand-600 text-xs flex items-center justify-center font-semibold" data-id="element-144">
                      2
                    </span>
                    <span data-id="element-145">Macul · 2D+1B</span>
                  </div>
                  <span className="font-medium" data-id="element-146">$810.000</span>
                </div>

                <div className="flex items-center justify-between text-sm" data-id="element-147">
                  <div className="flex items-center gap-2" data-id="element-148">
                    <span className="w-6 h-6 rounded-md bg-brand-100 text-brand-600 text-xs flex items-center justify-center font-semibold" data-id="element-149">
                      3
                    </span>
                    <span data-id="element-150">Santiago · Estudio</span>
                  </div>
                  <span className="font-medium" data-id="element-151">$590.000</span>
                </div>

                <div className="text-xs text-gray-400 text-center" data-id="element-152">
                  +2 opciones más disponibles
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mb-4" data-id="element-153">
                <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded-full" data-id="element-154">
                  Ingreso validado
                </span>
                <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded-full" data-id="element-155">
                  Sin DICOM
                </span>
                <span className="text-xs bg-yellow-100 text-yellow-600 px-2 py-1 rounded-full" data-id="element-156">
                  Aval recomendado
                </span>
              </div>

              <button className="w-full bg-gray-900 text-white py-3 rounded-lg font-medium" data-id="element-157">
                Revisar y postular
              </button>
            </div>

            {/* MINI CARD */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg border border-gray-100 p-4 w-52" data-id="element-158">
              <span className="text-xs text-gray-400 font-medium block mb-2" data-id="element-159">
                ANÁLISIS DE PERFIL
              </span>

              <div className="space-y-1 text-sm" data-id="element-160">
                <div className="flex justify-between" data-id="element-161">
                  <span data-id="element-162">Ingreso</span>
                  <span className="text-green-600 font-medium" data-id="element-163">OK</span>
                </div>

                <div className="flex justify-between" data-id="element-164">
                  <span data-id="element-165">DICOM</span>
                  <span className="text-green-600 font-medium" data-id="element-166">OK</span>
                </div>

                <div className="flex justify-between" data-id="element-167">
                  <span data-id="element-168">Aval</span>
                  <span className="text-yellow-600 font-medium" data-id="element-169">Faltante</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}